<template>
  <div class="js-basedata-cargroup app-container">
    <!-- 查询框 -->
    <app-search>
      <div slot="content">
          <el-form inline :model="listQuery" label-suffix="：" label-width="auto">
           <el-row >
            <el-col :span="7">
              <el-form-item :label="$t('public.licensePlate')">
                <el-input v-model="listQuery.licensePlate" clearable :placeholder="$t('overspeedAlarm.licensePlate')" />
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item :label="$t('public.startTime')">
                <el-row type="flex" justify="start" align="middle">
                  <el-col :span="10">
                    <el-date-picker
                      v-model="listQuery.startTime"
                      clearable
                      :placeholder="$t('public.startTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                  &emsp;<span  class="time-span" style="color:#ddd;">——</span>&emsp;
                  <el-col  :span="10">
                    <el-date-picker
                      v-model="listQuery.endTime"
                      clearable
                      :placeholder="$t('public.endTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>   
          </el-row>
        </el-form>
      </div>
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-export="handleExport"
      @click-filter="showfilter=true"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div v-if="item.prop==='licensePlate'">
            <vue-licenseplate
              :types="0"
              :licensepalte="scope.row[item.prop]"
              :area="scope.row['areaName']"
            />
          </div>
          <div v-else-if="item.prop==='message'">
              <el-popover
              placement="top-start"
              width="350"
              trigger="hover"
               :visible-arrow="false"
              :content="scope.row[item.prop]">
              <span slot="reference">{{ scope.row[item.prop] }}</span>
            </el-popover>
          </div>
          <div v-else>
            {{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from "@/mixins/getButton"
// 组件
// request
// import { getList, exportRecord } from '@/api/vehicleAlarm/overspeedAlarm'
import { getIgnitionReport ,exportIgnition} from '@/api/datareport/ignition'
export default {
  name: 'ignition',
  filters: {
    
  },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle,getPageButton],
  data() {
    return {
      listQuery: {},
      showfilter: false,
      tableList: [
        { value: this.$t('public.licensePlate'), prop: 'licensePlate', position: 'center',  width: 160, checked: true },
        { value: this.$t('carManagement.area'), prop: 'province', position: 'center',  width: 130, checked: true },
        { value: this.$t('carManagement.regVin'), prop: 'regVin', position: 'center',  width: 160, checked: true },
        { value: this.$t('carManagement.ecuVin'), prop: 'ecuVin', position: 'center',  width: 130, checked: true },
        { value: this.$t('public.obdCode'), prop: 'barCode', position: 'center',width: 130, checked: true },  
        {value: this.$t('public.ignitionlocation'), prop: 'lastLocation', position: 'center',width: 180,  checked: true },
        { value: this.$t('public.ignitiontime'), prop: 'lastTime', position: 'center',  width: 168, checked: true },
      ],
      buttonList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  methods: {
    // 加载数据
    listLoad() {
      const startTime = new Date(this.listQuery.starttime).getTime()
      const endTime = new Date(this.listQuery.endTime).getTime()
      if (startTime > endTime) {
        this.$message.error({
          message: this.$t('public.timeError'),
          duration: 2 * 1000
        })
        return
      }
      this.listLoading = true
      getIgnitionReport(this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
          let orderSort = 'mobile,licensePlate,barCode,startTime'
          this.setOrderField(orderSort, this.tableList)
          this.tableRow = {}
        }
        this.listLoading = false
      }).catch(()=>{
         this.listLoading = false
      })
    },
    handleExport() {
      exportIgnition(this.listQuery)
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
